import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const updateTopic = (data) => {
  return apiRequestType(apiTypes.PUT, apiConstants.ORGANIZE.UPDATE_TOPIC, data);
};

export default updateTopic;
